import {
  ga as VOID,
  y9 as ensureNotNull,
  a1 as Unit_getInstance,
  q7 as isBlank,
  s9 as THROW_CCE,
  p5 as classMeta,
  o6 as setMetadataFor,
  a8 as split,
  t3 as plus,
  s2 as joinToString,
  i3 as minus,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class HtmlElementBuilder {
  constructor(element) {
    this.element = element;
    this.attribute = new AttributeBuilder(this.element);
    this.on = new EventHandlerBuilder(this.element);
    this.class_ = new ClassBuilder(this.element);
    this.style = new StyleBuilder(this.element);
  }
  x4x() {
    return this.element;
  }
  y4x() {
    return this.attribute;
  }
  z4x() {
    return this.on;
  }
  a4y() {
    return this.class_;
  }
  l1y() {
    return this.style;
  }
  b4y(value) {
    this.element.textContent = value;
  }
  c4y() {
    return this.element.textContent;
  }
  d4y(tagName, init) {
    var child = ensureNotNull(this.element.ownerDocument).createElement(tagName);
    this.element.appendChild(child);
    init(new HtmlElementBuilder(child));
    return child;
  }
  htmlElement(tagName, init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$htmlElement$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.d4y(tagName, init);
  }
  e4y(init) {
    return this.htmlElement('a', init);
  }
  a(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$a$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.e4y(init);
  }
  f4y(init) {
    return this.htmlElement('address', init);
  }
  address(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$address$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.f4y(init);
  }
  g4y(init) {
    return this.htmlElement('article', init);
  }
  article(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$article$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.g4y(init);
  }
  h4y(init) {
    return this.htmlElement('aside', init);
  }
  aside(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$aside$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.h4y(init);
  }
  i4y(init) {
    return this.htmlElement('button', init);
  }
  button(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$button$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.i4y(init);
  }
  j4y(init) {
    return this.htmlElement('canvas', init);
  }
  canvas(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$canvas$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.j4y(init);
  }
  k4y(init) {
    return customElement(this, 'input', init, HtmlElementBuilder$checkbox$lambda_0);
  }
  checkbox(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$checkbox$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.k4y(init);
  }
  l4y(init) {
    return this.htmlElement('code', init);
  }
  code(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$code$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.l4y(init);
  }
  m4y(init) {
    return this.htmlElement('dialog', init);
  }
  dialog(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$dialog$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.m4y(init);
  }
  n4y(init) {
    return this.htmlElement('div', init);
  }
  div(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$div$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.n4y(init);
  }
  o4y(init) {
    return this.htmlElement('footer', init);
  }
  footer(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$footer$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.o4y(init);
  }
  p4y(init) {
    return this.htmlElement('header', init);
  }
  header(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$header$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.p4y(init);
  }
  q4y(init) {
    return this.htmlElement('h1', init);
  }
  h1(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$h1$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.q4y(init);
  }
  r4y(init) {
    return this.htmlElement('h2', init);
  }
  h2(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$h2$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.r4y(init);
  }
  s4y(init) {
    return this.htmlElement('h3', init);
  }
  h3(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$h3$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.s4y(init);
  }
  t4y(init) {
    return this.htmlElement('img', init);
  }
  img(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$img$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.t4y(init);
  }
  u4y(init) {
    return this.htmlElement('input', init);
  }
  input(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$input$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.u4y(init);
  }
  v4y(init) {
    return this.htmlElement('label', init);
  }
  label(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$label$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.v4y(init);
  }
  w4y(init) {
    return this.htmlElement('li', init);
  }
  li(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$li$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.w4y(init);
  }
  x4y(init) {
    return this.htmlElement('ol', init);
  }
  ol(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$ol$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.x4y(init);
  }
  y4y(init) {
    return this.htmlElement('optgroup', init);
  }
  optgroup(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$optgroup$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.y4y(init);
  }
  z4y(disabled, label, selected, value, init) {
    var tmp$ret$2;
    // Inline function 'kotlin.also' call
    var tmp0_also = this.htmlElement('option', init);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.kotlin.html5.HtmlElementBuilder.option.<anonymous>' call
    if (disabled) {
      tmp0_also.setAttribute('disabled', 'true');
    }
    var tmp$ret$0;
    // Inline function 'kotlin.text.isNotBlank' call
    tmp$ret$0 = !isBlank(label);
    if (tmp$ret$0) {
      tmp0_also.setAttribute('label', label);
    }
    if (selected) {
      tmp0_also.setAttribute('selected', 'true');
    }
    var tmp$ret$1;
    // Inline function 'kotlin.text.isNotBlank' call
    tmp$ret$1 = !isBlank(value);
    if (tmp$ret$1) {
      tmp0_also.setAttribute('value', value);
    }
    tmp$ret$2 = tmp0_also;
    return tmp$ret$2;
  }
  option(disabled, label, selected, value, init, $super) {
    disabled = disabled === VOID ? false : disabled;
    label = label === VOID ? '' : label;
    selected = selected === VOID ? false : selected;
    value = value === VOID ? '' : value;
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$option$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.z4y(disabled, label, selected, value, init);
  }
  a4z(init) {
    return this.htmlElement('p', init);
  }
  p(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$p$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.a4z(init);
  }
  b4z(init) {
    return this.htmlElement('progress', init);
  }
  progress(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$progress$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.b4z(init);
  }
  c4z(init) {
    return this.htmlElement('main', init);
  }
  main(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$main$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.c4z(init);
  }
  d4z(init) {
    return this.htmlElement('nav', init);
  }
  nav(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$nav$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.d4z(init);
  }
  e4z(init) {
    return customElement(this, 'input', init, HtmlElementBuilder$radio$lambda_0);
  }
  radio(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$radio$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.e4z(init);
  }
  f4z(init) {
    return this.htmlElement('section', init);
  }
  section(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$section$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.f4z(init);
  }
  g4z(init) {
    return this.htmlElement('select', init);
  }
  select(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$select$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.g4z(init);
  }
  h4z(init) {
    return this.htmlElement('span', init);
  }
  span(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$span$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.h4z(init);
  }
  i4z(init) {
    return this.htmlElement('table', init);
  }
  table(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$table$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.i4z(init);
  }
  j4z(init) {
    return this.htmlElement('textarea', init);
  }
  textarea(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$textarea$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.j4z(init);
  }
  k4z(init) {
    return this.htmlElement('ul', init);
  }
  ul(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$ul$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.k4z(init);
  }
  l4z(init) {
    var tmp = ensureNotNull(this.element.ownerDocument).createElementNS('http://www.w3.org/2000/svg', 'svg');
    var child = tmp instanceof SVGElement ? tmp : THROW_CCE();
    this.element.appendChild(child);
    init(new SvgElementBuilder(child));
    return child;
  }
  svg(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = HtmlElementBuilder$svg$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.l4z(init);
  }
  get content() {
    return this.c4y();
  }
  set content(value) {
    this.b4y(value);
  }
}
class AttributeBuilder {
  constructor(element) {
    this.element = element;
  }
  x4x() {
    return this.element;
  }
  get(attributeName) {
    return this.element.getAttribute(attributeName);
  }
  set(attributeName, value) {
    if (value == null) {
      this.element.removeAttribute(attributeName);
    } else {
      this.element.setAttribute(attributeName, value);
    }
  }
  m4z(value) {
    return this.set('checked', value);
  }
  n4z() {
    return this.get('checked');
  }
  o4z(value) {
    return this.set('class', value);
  }
  a4y() {
    return this.get('class');
  }
  p4z(value) {
    return this.set('contenteditable', value);
  }
  q4z() {
    return this.get('contenteditable');
  }
  r4z(value) {
    return this.set('height', value);
  }
  s4z() {
    return this.get('height');
  }
  t4z(value) {
    return this.set('id', value);
  }
  en() {
    return this.get('id');
  }
  u4z(value) {
    return this.set('for', value);
  }
  v4z() {
    return this.get('for');
  }
  w4z(value) {
    return this.set('name', value);
  }
  be() {
    return this.get('name');
  }
  x4z(value) {
    return this.set('style', value);
  }
  l1y() {
    return this.get('style');
  }
  y4z(value) {
    return this.set('type', value);
  }
  em() {
    return this.get('type');
  }
  z4z(value) {
    return this.set('value', value);
  }
  p3() {
    return this.get('value');
  }
  a50(value) {
    return this.set('width', value);
  }
  b50() {
    return this.get('width');
  }
  get checked() {
    return this.n4z();
  }
  set checked(value) {
    this.m4z(value);
  }
  get class_() {
    return this.a4y();
  }
  set class_(value) {
    this.o4z(value);
  }
  get contenteditable() {
    return this.q4z();
  }
  set contenteditable(value) {
    this.p4z(value);
  }
  get height() {
    return this.s4z();
  }
  set height(value) {
    this.r4z(value);
  }
  get id() {
    return this.en();
  }
  set id(value) {
    this.t4z(value);
  }
  get for_() {
    return this.v4z();
  }
  set for_(value) {
    this.u4z(value);
  }
  get name() {
    return this.be();
  }
  set name(value) {
    this.w4z(value);
  }
  get style() {
    return this.l1y();
  }
  set style(value) {
    this.x4z(value);
  }
  get type() {
    return this.em();
  }
  set type(value) {
    this.y4z(value);
  }
  get value() {
    return this.p3();
  }
  set value(value) {
    this.z4z(value);
  }
  get width() {
    return this.b50();
  }
  set width(value) {
    this.a50(value);
  }
}
class EventHandlerBuilder {
  constructor(element) {
    this.element = element;
  }
  x4x() {
    return this.element;
  }
  event(eventName, handler) {
    this.element.addEventListener(eventName, handler);
  }
  blur(handler) {
    return this.event('blur', handler);
  }
  change(handler) {
    return this.event('change', handler);
  }
  click(handler) {
    return this.event('click', handler);
  }
  dblclick(handler) {
    return this.event('dblclick', handler);
  }
  focus(handler) {
    return this.event('focus', handler);
  }
  select(handler) {
    return this.event('select', handler);
  }
}
class ClassBuilder {
  constructor(element) {
    this.element = element;
  }
  x4x() {
    return this.element;
  }
  get() {
    var tmp0_safe_receiver = this.element.getAttribute('class');
    return tmp0_safe_receiver == null ? null : split(tmp0_safe_receiver, [' ']);
  }
  add(value) {
    var list = this.get();
    if (list == null) {
      this.element.setAttribute('class', value);
    } else if (list.w(value)) {
    } else {
      var newValue = joinToString(plus(list, value), ' ');
      this.element.setAttribute('class', newValue);
    }
  }
  remove(value) {
    var list = this.get();
    if (list == null) {
    } else if (!list.w(value)) {
    } else {
      var newValue = joinToString(minus(list, value), ' ');
      this.element.setAttribute('class', newValue);
    }
  }
}
class SvgElementBuilder {
  constructor(parent) {
    this.parent = parent;
    this.attribute = new SVGAttributeBuilder(this.parent);
    this.class_ = new ClassBuilder(this.parent);
    this.style = new StyleBuilder(this.parent);
  }
  l2g() {
    return this.parent;
  }
  y4x() {
    return this.attribute;
  }
  a4y() {
    return this.class_;
  }
  l1y() {
    return this.style;
  }
  c50(tagName, init) {
    var tmp = ensureNotNull(this.parent.ownerDocument).createElementNS('http://www.w3.org/2000/svg', tagName);
    var child = tmp instanceof SVGElement ? tmp : THROW_CCE();
    this.parent.appendChild(child);
    init(new SvgElementBuilder(child));
    return child;
  }
  svgElement(tagName, init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = SvgElementBuilder$svgElement$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.c50(tagName, init);
  }
  d50(init) {
    return this.svgElement('defs', init);
  }
  defs(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = SvgElementBuilder$defs$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.d50(init);
  }
  e50(init) {
    return this.svgElement('marker', init);
  }
  marker(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = SvgElementBuilder$marker$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.e50(init);
  }
  f50(init) {
    return this.svgElement('path', init);
  }
  path(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = SvgElementBuilder$path$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.f50(init);
  }
  g50(init) {
    return this.svgElement('g', init);
  }
  g(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = SvgElementBuilder$g$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.g50(init);
  }
  h50(init) {
    return this.svgElement('circle', init);
  }
  circle(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = SvgElementBuilder$circle$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.h50(init);
  }
  i50(init) {
    return this.svgElement('rect', init);
  }
  rect(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = SvgElementBuilder$rect$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.i50(init);
  }
  j50(init) {
    return this.svgElement('line', init);
  }
  line(init, $super) {
    var tmp;
    if (init === VOID) {
      tmp = SvgElementBuilder$line$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return this.j50(init);
  }
}
class SVGAttributeBuilder {
  constructor(element) {
    this.element = element;
  }
  x4x() {
    return this.element;
  }
  get(attributeName) {
    return this.element.getAttributeNS(null, attributeName);
  }
  set(attributeName, value) {
    if (value == null) {
      this.element.removeAttributeNS(null, attributeName);
    } else {
      this.element.setAttributeNS(null, attributeName, value);
    }
  }
  k50(value) {
    return this.set('cx', value);
  }
  l50() {
    return this.get('cx');
  }
  m50(value) {
    return this.set('cy', value);
  }
  n50() {
    return this.get('cy');
  }
  o50(value) {
    return this.set('d', value);
  }
  p50() {
    return this.get('d');
  }
  q50(value) {
    return this.set('fill', value);
  }
  r50() {
    return this.get('fill');
  }
  t4z(value) {
    return this.set('id', value);
  }
  en() {
    return this.get('id');
  }
  r4z(value) {
    return this.set('height', value);
  }
  s4z() {
    return this.get('height');
  }
  s50(value) {
    return this.set('marker-end', value);
  }
  t50() {
    return this.get('marker-end');
  }
  u50(value) {
    return this.set('markerHeight', value);
  }
  v50() {
    return this.get('markerHeight');
  }
  w50(value) {
    return this.set('markerUnits', value);
  }
  x50() {
    return this.get('markerUnits');
  }
  y50(value) {
    return this.set('markerWidth', value);
  }
  z50() {
    return this.get('markerWidth');
  }
  a51(value) {
    return this.set('orient', value);
  }
  b51() {
    return this.get('orient');
  }
  c51(value) {
    return this.set('r', value);
  }
  d51() {
    return this.get('r');
  }
  e51(value) {
    return this.set('refX', value);
  }
  f51() {
    return this.get('refX');
  }
  g51(value) {
    return this.set('refY', value);
  }
  h51() {
    return this.get('refY');
  }
  i51(value) {
    return this.set('rx', value);
  }
  j51() {
    return this.get('rx');
  }
  k51(value) {
    return this.set('ry', value);
  }
  l51() {
    return this.get('ry');
  }
  m51(value) {
    return this.set('stroke', value);
  }
  n51() {
    return this.get('stroke');
  }
  o51(value) {
    return this.set('stroke-width', value);
  }
  p51() {
    return this.get('stroke-width');
  }
  q51(value) {
    return this.set('viewBox', value);
  }
  r51() {
    return this.get('viewBox');
  }
  a50(value) {
    return this.set('width', value);
  }
  b50() {
    return this.get('width');
  }
  s51(value) {
    return this.set('x', value);
  }
  t51() {
    return this.get('x');
  }
  u51(value) {
    return this.set('x1', value);
  }
  v51() {
    return this.get('x1');
  }
  w51(value) {
    return this.set('x2', value);
  }
  x51() {
    return this.get('x2');
  }
  y51(value) {
    return this.set('y', value);
  }
  z51() {
    return this.get('y');
  }
  a52(value) {
    return this.set('y1', value);
  }
  b52() {
    return this.get('y1');
  }
  c52(value) {
    return this.set('y2', value);
  }
  d52() {
    return this.get('y2');
  }
  get cx() {
    return this.l50();
  }
  set cx(value) {
    this.k50(value);
  }
  get cy() {
    return this.n50();
  }
  set cy(value) {
    this.m50(value);
  }
  get d() {
    return this.p50();
  }
  set d(value) {
    this.o50(value);
  }
  get fill() {
    return this.r50();
  }
  set fill(value) {
    this.q50(value);
  }
  get id() {
    return this.en();
  }
  set id(value) {
    this.t4z(value);
  }
  get height() {
    return this.s4z();
  }
  set height(value) {
    this.r4z(value);
  }
  get marker_end() {
    return this.t50();
  }
  set marker_end(value) {
    this.s50(value);
  }
  get markerHeight() {
    return this.v50();
  }
  set markerHeight(value) {
    this.u50(value);
  }
  get markerUnits() {
    return this.x50();
  }
  set markerUnits(value) {
    this.w50(value);
  }
  get markerWidth() {
    return this.z50();
  }
  set markerWidth(value) {
    this.y50(value);
  }
  get orient() {
    return this.b51();
  }
  set orient(value) {
    this.a51(value);
  }
  get r() {
    return this.d51();
  }
  set r(value) {
    this.c51(value);
  }
  get refX() {
    return this.f51();
  }
  set refX(value) {
    this.e51(value);
  }
  get refY() {
    return this.h51();
  }
  set refY(value) {
    this.g51(value);
  }
  get rx() {
    return this.j51();
  }
  set rx(value) {
    this.i51(value);
  }
  get ry() {
    return this.l51();
  }
  set ry(value) {
    this.k51(value);
  }
  get stroke() {
    return this.n51();
  }
  set stroke(value) {
    this.m51(value);
  }
  get stroke_width() {
    return this.p51();
  }
  set stroke_width(value) {
    this.o51(value);
  }
  get viewBox() {
    return this.r51();
  }
  set viewBox(value) {
    this.q51(value);
  }
  get width() {
    return this.b50();
  }
  set width(value) {
    this.a50(value);
  }
  get x() {
    return this.t51();
  }
  set x(value) {
    this.s51(value);
  }
  get x1() {
    return this.v51();
  }
  set x1(value) {
    this.u51(value);
  }
  get x2() {
    return this.x51();
  }
  set x2(value) {
    this.w51(value);
  }
  get y() {
    return this.z51();
  }
  set y(value) {
    this.y51(value);
  }
  get y1() {
    return this.b52();
  }
  set y1(value) {
    this.a52(value);
  }
  get y2() {
    return this.d52();
  }
  set y2(value) {
    this.c52(value);
  }
}
class StyleBuilder {
  constructor(element) {
    this.e52_1 = element;
  }
}
//endregion
function head(_this__u8e3s4, init) {
  var tmp;
  if (init === VOID) {
    tmp = head$lambda;
  } else {
    tmp = init;
  }
  init = tmp;
  var child = _this__u8e3s4.createElement('head');
  _this__u8e3s4.appendChild(child);
  init(new HtmlElementBuilder(child));
  return child;
}
function body(_this__u8e3s4, init) {
  var tmp;
  if (init === VOID) {
    tmp = body$lambda;
  } else {
    tmp = init;
  }
  init = tmp;
  var child = _this__u8e3s4.createElement('body');
  _this__u8e3s4.appendChild(child);
  init(new HtmlElementBuilder(child));
  return child;
}
function update(_this__u8e3s4, modifications) {
  var tmp;
  if (modifications === VOID) {
    tmp = update$lambda;
  } else {
    tmp = modifications;
  }
  modifications = tmp;
  var b = new HtmlElementBuilder(_this__u8e3s4);
  modifications(b);
}
function create(_this__u8e3s4) {
  return new HtmlElementBuilder(_this__u8e3s4);
}
function create_0(_this__u8e3s4) {
  return new SvgElementBuilder(_this__u8e3s4);
}
function svgUpdate(_this__u8e3s4, modifications) {
  var tmp;
  if (modifications === VOID) {
    tmp = svgUpdate$lambda;
  } else {
    tmp = modifications;
  }
  modifications = tmp;
  var b = new SvgElementBuilder(_this__u8e3s4);
  modifications(b);
}
function customElement($this, tagName, init, customBuild) {
  var child = ensureNotNull($this.element.ownerDocument).createElement(tagName);
  $this.element.appendChild(child);
  var b = new HtmlElementBuilder(child);
  customBuild(b);
  init(b);
  return child;
}
function customElement$default($this, tagName, init, customBuild, $super) {
  var tmp;
  if (init === VOID) {
    tmp = HtmlElementBuilder$customElement$lambda;
  } else {
    tmp = init;
  }
  init = tmp;
  var tmp_0;
  if (customBuild === VOID) {
    tmp_0 = HtmlElementBuilder$customElement$lambda_0;
  } else {
    tmp_0 = customBuild;
  }
  customBuild = tmp_0;
  return customElement($this, tagName, init, customBuild);
}
function HtmlElementBuilder$htmlElement$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$customElement$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$customElement$lambda_0($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$a$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$address$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$article$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$aside$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$button$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$canvas$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$checkbox$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$checkbox$lambda_0($this$customElement) {
  $this$customElement.attribute.type = 'checkbox';
  return Unit_getInstance();
}
function HtmlElementBuilder$code$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$dialog$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$div$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$footer$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$header$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$h1$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$h2$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$h3$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$img$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$input$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$label$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$li$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$ol$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$optgroup$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$option$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$p$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$progress$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$main$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$nav$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$radio$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$radio$lambda_0($this$customElement) {
  $this$customElement.attribute.type = 'radio';
  return Unit_getInstance();
}
function HtmlElementBuilder$section$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$select$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$span$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$table$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$textarea$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$ul$lambda($this$null) {
  return Unit_getInstance();
}
function HtmlElementBuilder$svg$lambda($this$null) {
  return Unit_getInstance();
}
function SvgElementBuilder$svgElement$lambda($this$null) {
  return Unit_getInstance();
}
function SvgElementBuilder$defs$lambda($this$null) {
  return Unit_getInstance();
}
function SvgElementBuilder$marker$lambda($this$null) {
  return Unit_getInstance();
}
function SvgElementBuilder$path$lambda($this$null) {
  return Unit_getInstance();
}
function SvgElementBuilder$g$lambda($this$null) {
  return Unit_getInstance();
}
function SvgElementBuilder$circle$lambda($this$null) {
  return Unit_getInstance();
}
function SvgElementBuilder$rect$lambda($this$null) {
  return Unit_getInstance();
}
function SvgElementBuilder$line$lambda($this$null) {
  return Unit_getInstance();
}
function head$lambda($this$null) {
  return Unit_getInstance();
}
function body$lambda($this$null) {
  return Unit_getInstance();
}
function update$lambda($this$null) {
  return Unit_getInstance();
}
function svgUpdate$lambda($this$null) {
  return Unit_getInstance();
}
//region block: post-declaration
setMetadataFor(HtmlElementBuilder, 'HtmlElementBuilder', classMeta);
setMetadataFor(AttributeBuilder, 'AttributeBuilder', classMeta);
setMetadataFor(EventHandlerBuilder, 'EventHandlerBuilder', classMeta);
setMetadataFor(ClassBuilder, 'ClassBuilder', classMeta);
setMetadataFor(SvgElementBuilder, 'SvgElementBuilder', classMeta);
setMetadataFor(SVGAttributeBuilder, 'SVGAttributeBuilder', classMeta);
setMetadataFor(StyleBuilder, 'StyleBuilder', classMeta);
//endregion
//region block: exports
HtmlElementBuilder.customElement$default = customElement$default;
export {
  head,
  body,
  update,
  create,
  svgUpdate,
  HtmlElementBuilder,
  AttributeBuilder,
  EventHandlerBuilder,
  ClassBuilder,
  SvgElementBuilder,
  SVGAttributeBuilder,
};
export {
  create as a,
  update as b,
};
//endregion

//# sourceMappingURL=net.akehurst.kotlin.html5-html-builder.mjs.map
